import React, { Component } from 'react';
import './Item.css'
import WorkDocCheckCarBeforeFixingDoc from '../../workdoc/WorkDocCheckCarBeforeFixingDoc'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    
  }

  onItemSelect() {

  }

  render() {
    return(
  		<div>
        <h3>{this.props.messages['Car Fixing Config']}</h3>
        <WorkDocCheckCarBeforeFixingDoc 
          
        />
  		</div>
  	)
  }

}
 
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu15.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu15/Item.js